import Vue from "vue";
import Vuex from "vuex";
import globals from "@/store/globals.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    globals
  }
});
